// Curated Los Cabos imagery extracted from the official Meeting Planner Guide PDF.
// All served locally from /public/cabos/.
export const LOGO_LOS_CABOS = "/brand/logo-loscabos.png";
export const HERO_IMAGE = "/brand/hero-arch-paddleboard.jpg";
export const HERO_MOBILE_IMAGE = "/cabos/cabos-01.jpg";

// Images from the official Meeting Planner Guide, tagged by topic.
export const GUIDE_IMAGES = {
  arch: { src: "/cabos/cabos-01.jpg", caption: "The Arch of Cabo San Lucas — Land's End" },
  arch_wide: { src: "/cabos/cabos-13.jpg", caption: "Land's End coastline, where the Sea of Cortés meets the Pacific" },
  event_cactus: { src: "/cabos/cabos-03.jpg", caption: "Open-air group dinner among cactus and mountains" },
  art_district: { src: "/cabos/cabos-04.jpg", caption: "San José del Cabo Art District — Thursday Art Walk" },
  aerial_resort: { src: "/cabos/cabos-05.jpg", caption: "Aerial view of the Tourist Corridor beaches" },
  gala_music: { src: "/cabos/cabos-06.jpg", caption: "Private gala dinner with live music" },
  golf_ocean: { src: "/cabos/cabos-07.jpg", caption: "Signature golf course facing the Sea of Cortés" },
  rooftop: { src: "/cabos/cabos-08.jpg", caption: "Rooftop corporate celebration with fireworks" },
  beach_yoga: { src: "/cabos/cabos-09.jpg", caption: "Sunrise beach yoga — Well-Being Program" },
  banquet_ocean: { src: "/cabos/cabos-10.jpg", caption: "Oceanfront banquet at a luxury resort" },
  beach_palms: { src: "/cabos/cabos-11.jpg", caption: "Palm-lined Blue Flag beach" },
  conference: { src: "/cabos/cabos-12.jpg", caption: "Modern conference & general session hall" },
  wedding_flowers: { src: "/cabos/cabos-14.jpg", caption: "Colorful banquet setup with Baja florals" },
  farm_dinner: { src: "/cabos/cabos-15.jpg", caption: "Farm-to-table dinner under Baja stars" },
  sunset_banquet: { src: "/cabos/cabos-16.jpg", caption: "Sunset banquet on the Sea of Cortés" },
  marina: { src: "/cabos/cabos-17.jpg", caption: "Cabo San Lucas Marina panoramic view" },
  sailing: { src: "/cabos/cabos-18.jpg", caption: "Luxury sunset sailing — group incentives" },
  adventure_bridge: { src: "/cabos/cabos-19.jpg", caption: "Wild Canyon adventure — team building" },
  private_beach_dinner: { src: "/cabos/cabos-20.jpg", caption: "Intimate beachfront gala dinner" },
  boardroom: { src: "/cabos/cabos-21.jpg", caption: "Executive boardroom with ocean views" },
  golf_tee: { src: "/cabos/cabos-22.jpg", caption: "Championship golf on the tip of Baja" },
};

// Keyword → image mapping so bot responses are paired with contextual imagery.
export function pickImageForContent(text) {
  const t = (text || "").toLowerCase();
  const hasWord = (kw) => {
    // Word-boundary aware match so 'spa' does not match 'Golf & Spa Resort' names, etc.
    const re = new RegExp(`(?:^|[^a-záéíóúñ])${kw.toLowerCase().replace(/[.*+?^${}()|[\]\\]/g, "\\$&")}(?:[^a-záéíóúñ]|$)`, "i");
    return re.test(t);
  };

  // Rules are matched in order — put the most specific / user-intent-first.
  const rules = [
    [["yoga", "wellness", "well-being", "bienestar", "meditación", "sunrise yoga"], ["beach_yoga"]],
    [["boardroom", "junta directiva", "sala de juntas"], ["boardroom"]],
    [["conference room", "general session", "convention hall", "auditorio", "sala plenaria"], ["conference"]],
    [["sailing", "yacht", "catamaran", "velero", "navegación", "sunset cruise", "regata"], ["sailing"]],
    [["adventure", "atv", "utv", "zipline", "aventura", "off-road", "off road", "wild canyon"], ["adventure_bridge"]],
    [["marina", "puerto"], ["marina"]],
    [["wedding", "boda"], ["wedding_flowers"]],
    [["rooftop", "fireworks", "fuegos artificiales"], ["rooftop"]],
    [["art district", "art walk", "papel picado"], ["art_district"]],
    [["beachfront", "frente al mar", "oceanfront", "beach", "playa", "blue flag"], ["beach_palms", "aerial_resort", "sunset_banquet"]],
    [["farm-to-table", "farm to table", "flora farms", "acre restaurant", "huerta", "farm-fresh"], ["farm_dinner"]],
    [["gala", "banquet", "banquete", "reception", "gastronom"], ["gala_music", "sunset_banquet", "banquet_ocean", "private_beach_dinner"]],
    [["arch", "el arco", "land's end", "lands end"], ["arch", "arch_wide"]],
    [["golf course", "golf club", "campo de golf", "nicklaus", "tom fazio"], ["golf_ocean", "golf_tee"]],
    [["ballroom", "salón principal", "salón de eventos"], ["banquet_ocean", "aerial_resort"]],
    [["incentive", "incentivo", "corporate retreat", "mice"], ["event_cactus", "sunset_banquet"]],
  ];

  for (const [keywords, imgKeys] of rules) {
    if (keywords.some(hasWord)) {
      const key = imgKeys[Math.floor(Math.random() * imgKeys.length)];
      return GUIDE_IMAGES[key];
    }
  }
  return null;
}
